import { baths } from "../../shared/listing";
import LabelValue from "../../search/result/label-value";
import { Link } from "react-router";
import Price from "../../search/result/price";
import PropTypes from "prop-types";
import React from "react";
import SlideShow from "../../search/result/mini-slideshow/";
import { LISTING_TYPES } from "../../../constants/constants";

const Listing = ({
  listing,
  options,
  index,
  buildGlobalDetailPage,
  isGlobal,
}) => {
  let globalListingLink;

  if (isGlobal) {
    globalListingLink = `/global-real-estate/sales/${listing.identifier}`;
  }

  const titleElement = <h3>{listing.title}</h3>;

  return (
    <div className={"result-item " + options.outerClasses}>
      <div className="row" aria-label="listing" role="group">
        <div className={options.innerClasses}>
          <SlideShow
            listing={listing}
            link={globalListingLink || listing.listingLink}
            buildGlobalDetailPage={buildGlobalDetailPage}
          />
        </div>
        <div className={"result-info " + options.innerClasses}>
          <div className="result-info-inner">
            <div className="title">
              {buildGlobalDetailPage ? (
                <Link to={globalListingLink || listing.listingLink}>
                  {titleElement}
                </Link>
              ) : (
                <a target="_blank" href={listing.listingLink}>
                  {titleElement}
                </a>
              )}
            </div>
            <div className="header-standard fancy">
              {listing.cityStateCountry}
            </div>
            <ul className="short-info">
              <LabelValue label="Bedrooms" value={listing.totalBedrooms} />
              <LabelValue label="Baths" value={baths(listing)} />
              <LabelValue
                label="Interior"
                value={listing.interiorSize
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                suffix="sq. ft. (approx.)"
              />
            </ul>
            <div class="short-info">
              <LabelValue
                label="Listing Courtesy of"
                value={listing.courtesyOf}
              />
            </div>
            <div className="price-outer">
              {listing.closedDate &&
              listing.listingType === LISTING_TYPES.SALE ? (
                listing.showPrice ? (
                  <span>
                    {listing.isDisplayPriceSoldPrice
                      ? "Sold Price: "
                      : "Last Asking: "}
                    <Price listing={listing} showRentalsTermsInDropdown />
                  </span>
                ) : (
                  ""
                )
              ) : (
                <Price listing={listing} showRentalsTermsInDropdown />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Listing.propTypes = {
  listing: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default Listing;



// WEBPACK FOOTER //
// ./src/components/homepage/featured/listing.js